import * as validators from './formValidators';

export const validateNotesForm = (values) => {
    let errors = {};
    let notes = values['Notes'];

    let error = validators.validateText(notes, 'Notes', 50000);
    errors = { ...errors, ...error };
    return errors;
};